<template>
	<div>
		<img :src="options.img" @click="open=true" title="点击上传头像" class="img-circle img-lg" />
		<el-dialog title="修改头像" :visible.sync="open" width="800px">
			<el-row>
				<el-col :xs="24" :md="12" :style="{height: '350px'}">
					<vue-cropper ref="cropper" :img="options.img" :info="true" :autoCrop="options.autoCrop" :autoCropWidth="options.autoCropWidth"
					 :autoCropHeight="options.autoCropHeight" :fixedBox="options.fixedBox" @realTime="realTime" @cropMoving="cropMoving" />
				</el-col>
				<el-col :xs="24" :md="12" :style="{height: '350px'}">
					<div class="avatar-upload-preview">
						<img :src="previews.url" :style="previews.img" />
					</div>
				</el-col>
			</el-row>
			<br />
			<el-row>
				<el-col :lg="2" :md="2">
					<el-upload action="#" :http-request="requestUpload" :show-file-list="false" :before-upload="beforeUpload">
						<el-button size="small">
							上传
							<i class="el-icon-upload el-icon--right"></i>
						</el-button>
					</el-upload>
				</el-col>
				<el-col :lg="{span: 1, offset: 2}" :md="2">
					<el-button icon="el-icon-plus" size="small" @click="changeScale(1)"></el-button>
				</el-col>
				<el-col :lg="{span: 1, offset: 1}" :md="2">
					<el-button icon="el-icon-minus" size="small" @click="changeScale(-1)"></el-button>
				</el-col>
				<el-col :lg="{span: 1, offset: 1}" :md="2">
					<el-button icon="el-icon-refresh-left" size="small" @click="rotateLeft()"></el-button>
				</el-col>
				<el-col :lg="{span: 1, offset: 1}" :md="2">
					<el-button icon="el-icon-refresh-right" size="small" @click="rotateRight()"></el-button>
				</el-col>
				<el-col :lg="{span: 2, offset: 6}" :md="2">
					<el-button type="primary" size="small" @click="uploadImg()">提 交</el-button>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
	import {
		VueCropper
	} from "vue-cropper";
	import {
		uploadAvatar
	} from "@/api/system/user";

	export default {
		components: {
			VueCropper
		},
		data() {
			return {
				// 是否显示弹出层
				open: false,
				options: {
					img: process.env.VUE_APP_BASE_API + this.$store.getters['user/avatar'],
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 200, // 默认生成截图框宽度
					autoCropHeight: 200, // 默认生成截图框高度
					fixedBox: true // 固定截图框大小 不允许改变
				},
				previews: {}
			};
		},
		methods: {
			// 覆盖默认的上传行为
			requestUpload() {},
			// 向左旋转
			rotateLeft() {
				this.$refs.cropper.rotateLeft();
			},
			// 向右旋转
			rotateRight() {
				this.$refs.cropper.rotateRight();
			},
			// 图片缩放
			changeScale(num) {
				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},
			// 上传预处理
			beforeUpload(file) {
				if (file.type.indexOf("image/") == -1) {
					this.msgError("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
				} else {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						this.options.img = reader.result;
					};
				}
			},
			// 上传图片
			uploadImg() {
				let _this = this;
				this.$refs.cropper.getCropData((base64) => {
					uploadAvatar({
						img64: base64
					}).then(res => {
						if (res.data.code === 0) {
							_this.open = false;
							_this.options.img = process.env.VUE_APP_BASE_API + res.data.data.url;
							_this.$store.commit('user/SET_USER_AVATAR', res.data.data.url);
							_this.$success("修改成功");
						} 
						// else {
						// 	_this.$fail(res.data.msg);
						// }
						_this.$refs.cropper.clearCrop();
					});
				});
			},
			// 实时预览
			realTime(data) {
				this.previews = data;
			}, //实时坐标
			cropMoving(moving) {
				//console.log(moving)
			}
		}
	};
</script>
<style lang="scss">
	.img-lg {
		width: 120px;
		height: 120px;
	}

	.img-circle {
		border-radius: 50%;
	}

	.avatar-upload-preview {
		position: absolute;
		top: 50%;
		transform: translate(50%, -50%);
		width: 200px;
		height: 200px;
		border-radius: 50%;
		box-shadow: 0 0 4px #ccc;
		overflow: hidden;
	}
</style>
